import { Injectable, signal } from '@angular/core';

/**
 * Opens/closes the full-screen cross-product home hub overlay. The overlay
 * itself is rendered once at the app root (see AppComponent); triggers (the
 * sidebar's product name) just call open().
 */
@Injectable({
  providedIn: 'root'
})
export class HomeHubOverlayService {
  readonly isOpen = signal(false);

  open(): void {
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
  }
}
